import * as THREE from "three";

/** Glass slots (named "*Glass*" in the Blender source, e.g. "aiStandardSurface3SG_Glass") are excluded from lightmapping. */
export function IsGlassMaterial(mat: THREE.Material|n) {
	// ignore the "__<ObjectName>" suffix added by the Blender bake script's material-unsharing (e.g. "..._1001__GlassWall_W" is a frame)
	return mat != null && /glass/i.test(mat.name.split("__")[0]);
}
